import { Collapse } from 'antd';
import React from 'react'
import { UseFormRegister } from 'react-hook-form';

import './styles.css';

interface AccordionProps {
  register: UseFormRegister<any>;
  className?: string;
  header: React.ReactNode;
  footer: React.ReactNode;
  children: React.ReactNode;
  expandIcon?: React.ReactNode[];
  expandIconPosition?: "start" | "end";
  isCollapsible?: 'disabled' | 'header'
}

const Accordion: React.FC<AccordionProps> = ({
  register,
  className = '',
  header,
  footer,
  children,
  expandIcon = [],
  expandIconPosition = 'end',
  isCollapsible = 'header',
}) => {
  return (
    <Collapse
      {...register}
      collapsible={isCollapsible}
      className={`shadow-sm rounded-2xl border border-solid border-[#e9e9eb] ${className}`}
      defaultActiveKey={['1']}
      bordered={false}
      expandIconPosition={expandIconPosition}
      expandIcon={({ isActive }) => isActive ? expandIcon[1] : expandIcon[0]}
      items={[{
        label: header,
        key: '1',
        children: (
          <React.Fragment>
            {children}
            {footer}
          </React.Fragment>
        )
      }]}
    />
  )
}

export default Accordion